import { SmallDesignCardWrapper } from "../../styles/StyledComponents/SmallDesignCardWrapper";
import { CommonOverlayBoxWrapper } from "../../styles/StyledComponents/WhatweDoCompWrapper";
import CommonButton from "../../ui/CommonButton/CommonButton";
import {
    ICommonOverlayBoxProps,
    ISmallDesignCardProps,
} from "../../ui/interface";

export const CommonOverlayBox = ({
  overlayBgImg,
  title,
  isH3,
  descriptionText,
  btnText,
}: ICommonOverlayBoxProps) => {
  return (
    <CommonOverlayBoxWrapper>
      <figure>
        <img src={overlayBgImg} alt={overlayBgImg} />
      </figure>
      <div className="details_text_div">
        {title && isH3 ? <h3>{title}</h3> : <h2>{title}</h2>}
        {descriptionText && <p>{descriptionText}</p>}
        {btnText && (
          <div className="details_btn_Wrap">
            <CommonButton variant="contained" color="primary">
              {btnText}
            </CommonButton>
          </div>
        )}
      </div>
    </CommonOverlayBoxWrapper>
  );
};

export const SmallDesignCard = ({
  detailsText,
  icon,
}: ISmallDesignCardProps) => {
  return (
    <SmallDesignCardWrapper>
      <i>{icon}</i>
      <p>{detailsText}</p>
    </SmallDesignCardWrapper>
  );
};
